import { type ReactNode } from 'react';
import { type Maybe } from '@models/Maybe';
import { CopyProjectToastShell } from './CopyProjectToastShell';
import { useCopyProjectName } from './copy-project-registry';

interface CopyProjectFailedToastContentProps {
    projectID: string;
    errorCode: Maybe<string>;
}

export function CopyProjectFailedToastContent({
    projectID,
    errorCode,
}: CopyProjectFailedToastContentProps): ReactNode {
    const projectName = useCopyProjectName(projectID);
    const resolvedErrorCode = errorCode ?? '';
    const subject = projectName ? `Project "${projectName}"` : 'The project';
    return (
        <CopyProjectToastShell iconName="error" title="Something went wrong">
            <span>{`${subject} couldn't be copied. Please try again. If the issue persists, contact support.`}</span>
            {resolvedErrorCode ? (
                <strong>{`Error code: ${resolvedErrorCode}`}</strong>
            ) : null}
        </CopyProjectToastShell>
    );
}
